/**
 * MISMO review tile (product page).
 * Markup and data come from blocks/mismo-review-tile.liquid: JSON in [data-mrt-data], one hidden holder with a <dialog>.
 * The tile cycles the highlight phrases of the reviews of one showcase (see the choice order in blocks/mismo-review-tile.liquid).
 * With no usable review the script hides the block.
 * A click on the phrase or on "Read the review" opens the shared MISMO review pop-up (assets/mismo-review-dialog.js and .css).
 * The pop-up opens the same way as on the Results page: the holder gets __review, then the hidden open button is pressed.
 * Cycle speed: data-speed in ms (0 = off). The cycle pauses on hover, focus, an open pop-up, a hidden tab and when the tile is off screen.
 * With "reduce motion" the cycle is off and there is no fade.
 * The name row stays on one line: a long name fades out; below 481px the word "Verified" drops out only when the name would be cut.
 * A quote that is too long for the fixed tile fades out at the bottom (class is-fade).
 * A short line above the tile (data-lead, for example "Real people. Real results.") shows only when the tile has reviews.
 * The quote fills the tile with whole lines and no fade. The script measures the box and adds words around the first marked phrase
 * (about 40% before it, 60% after it) until one more word would not fit. A cut end shows "…". Every marked phrase inside the text shows marked.
 * The tile starts on the first review (the order comes from the pins). A short review shows in full. A first phrase too long for the box is cut at its end. The script fits the text again when the window size changes.
 */
(function () {
  if (window.__mrtLoaded) return;
  window.__mrtLoaded = true;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FADE = 200;

  // Share of the added words that go before the first marked phrase.
  var BEFORE = 0.4;

  var esc = function (v) {
    return String(v == null ? '' : v)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  };

  var TICK =
    '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false"><path fill="currentColor" d="M12 2a10 10 0 100 20 10 10 0 000-20zm-1.2 14.4l-4-4 1.4-1.4 2.6 2.6 5-5 1.4 1.4-6.4 6.4z"/></svg>';
  var CHL = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHR = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  // One slide per review (its first usable phrase). One dot below the tile belongs to each slide.
  function buildSlides(reviews) {
    var out = [];
    reviews.forEach(function (r) {
      var body = String(r.b || '');
      var first = null;
      (r.hi || []).forEach(function (p) {
        if (first || typeof p !== 'string') return;
        p = p.trim();
        if (p.length < 12 || body.indexOf(p) < 0) return;
        first = p;
      });
      if (first) out.push({ r: r, p: first });
    });
    return out;
  }

  // Start and end offset of every word in the body.
  function wordsOf(body) {
    var w = [];
    var re = /\S+/g;
    var m;
    while ((m = re.exec(body))) w.push([m.index, m.index + m[0].length]);
    return w;
  }

  // Marked ranges: every usable highlight phrase of the review, in text order, overlaps joined.
  function rangesOf(body, s) {
    var list = [];
    function add(p) {
      if (typeof p !== 'string') return;
      p = p.trim();
      if (p.length < 12) return;
      var at = body.indexOf(p);
      if (at > -1) list.push([at, at + p.length]);
    }
    add(s.p);
    (s.r.hi || []).forEach(add);
    list.sort(function (a, b) { return a[0] - b[0]; });
    var out = [];
    list.forEach(function (r) {
      var last = out[out.length - 1];
      if (last && r[0] <= last[1]) last[1] = Math.max(last[1], r[1]);
      else out.push([r[0], r[1]]);
    });
    return out;
  }

  // The text of words a..b with the marked ranges inside it, and "…" where the review goes on.
  function windowHtml(body, w, marks, a, b) {
    var cs = w[a][0];
    var ce = w[b][1];
    var out = '';
    var pos = cs;
    marks.forEach(function (r) {
      var rs = Math.max(r[0], cs);
      var re = Math.min(r[1], ce);
      if (rs >= re) return;
      out += esc(body.slice(pos, rs)) + '<mark class="mrt__hi">' + esc(body.slice(rs, re)) + '</mark>';
      pos = re;
    });
    out += esc(body.slice(pos, ce));
    return (a > 0 ? '… ' : '') + out + (b < w.length - 1 ? ' …' : '');
  }

  // Fill the quote box with whole lines: the first marked phrase, then words around it, as many as fit.
  function fillQuote(q, s) {
    var body = String(s.r.b || '');
    var w = wordsOf(body);
    var n = w.length;
    if (!n) return;
    var marks = rangesOf(body, s);
    var at = body.indexOf(s.p);
    var wa = 0;
    var wb = n - 1;
    for (var x = 0; x < n; x++) {
      if (w[x][1] > at) { wa = x; break; }
    }
    for (var y = wa; y < n; y++) {
      if (w[y][1] >= at + s.p.length) { wb = y; break; }
    }
    function fits() {
      return q.scrollHeight <= q.clientHeight + 1;
    }
    function show(a, b) {
      q.innerHTML = windowHtml(body, w, marks, a, b);
    }
    if (q.clientHeight < 20) {
      show(Math.max(0, wa - 4), Math.min(n - 1, wb + 8));
      return;
    }
    show(0, n - 1);
    if (fits()) return;
    var lo;
    var hi;
    var m;
    // Words around the phrase: most that fit, found by halving.
    function around(k) {
      var after = Math.min(n - 1 - wb, k - Math.min(wa, Math.round(k * BEFORE)));
      var before = Math.min(wa, k - after);
      return [wa - before, wb + after];
    }
    var maxK = n - (wb - wa + 1);
    show(wa, wb);
    if (!fits()) {
      // The first phrase is too long for the box: keep its first words only.
      lo = 1;
      hi = wb - wa;
      while (lo < hi) {
        m = Math.ceil((lo + hi) / 2);
        show(wa, wa + m - 1);
        if (fits()) lo = m;
        else hi = m - 1;
      }
      show(wa, wa + lo - 1);
      return;
    }
    lo = 0;
    hi = maxK;
    while (lo < hi) {
      m = Math.ceil((lo + hi) / 2);
      var r = around(m);
      show(r[0], r[1]);
      if (fits()) lo = m;
      else hi = m - 1;
    }
    var f = around(lo);
    show(f[0], f[1]);
  }

  function slideHtml(s) {
    var r = s.r;
    var name = r.n || 'MISMO customer';
    return (
      '<button type="button" class="mrt__slide" data-mrt-open aria-label="Read the full review by ' + esc(name) + '">' +
      '<span class="mrt__q"></span>' +
      '<span class="mrt__who">' +
      '<span class="mrt__av" aria-hidden="true">' + esc(name.charAt(0).toUpperCase()) + '</span>' +
      '<span class="mrt__nm"><b>' + esc(name) + '</b></span>' +
      (r.v ? '<span class="mrt__vg"><span class="mrt__tick" role="img" aria-label="Verified buyer">' + TICK + '</span><span class="mrt__vt">Verified</span></span>' : '') +
      '<span class="mrt__go">Read <span class="mrt__th">the </span>review</span>' +
      '</span>' +
      '</button>'
    );
  }

  function init(root) {
    if (root.__mrtReady) return;
    var dataEl = root.querySelector('[data-mrt-data]');
    var panel = root.querySelector('[data-mrt-panel]');
    var holder = root.querySelector('.mrt__holder');
    if (!dataEl || !panel || !holder) return;
    var reviews = [];
    try {
      reviews = JSON.parse(dataEl.textContent) || [];
    } catch (e) {}
    var slides = buildSlides(reviews);
    if (!slides.length) {
      // No usable review: hide the whole block (no empty box, no gap).
      root.style.display = 'none';
      return;
    }
    root.__mrtReady = true;

    var speed = REDUCE ? 0 : Number(root.getAttribute('data-speed')) || 0;
    var many = slides.length > 1;
    panel.innerHTML =
      (many ? '<button type="button" class="mrt__ar mrt__ar--p" data-mrt-prev aria-label="Previous review">' + CHL + '</button>' : '') +
      '<div class="mrt__stage" aria-live="off"></div>' +
      (many ? '<button type="button" class="mrt__ar mrt__ar--n" data-mrt-next aria-label="Next review">' + CHR + '</button>' : '');
    panel.hidden = false;
    var lead = (root.getAttribute('data-lead') || '').trim();
    if (lead && !root.querySelector('.mrt__lead')) {
      panel.insertAdjacentHTML('beforebegin', '<p class="mrt__lead">' + esc(lead) + '</p>');
    }
    var dotsEl = null;
    if (many) {
      var dh = '';
      for (var d = 0; d < slides.length; d++) {
        dh += '<button type="button" class="mrt__dot" data-mrt-dot="' + d + '" aria-label="Review ' + (d + 1) + ' of ' + slides.length + '"></button>';
      }
      panel.insertAdjacentHTML('afterend', '<div class="mrt__dots">' + dh + '</div>');
      dotsEl = root.querySelector('.mrt__dots');
    }
    var stage = panel.querySelector('.mrt__stage');
    var i = 0;
    var timer = null;
    var hold = { hover: false, focus: false, off: false, hidden: document.hidden };

    function fit() {
      var nm = stage.querySelector('.mrt__nm');
      if (!nm) return;
      stage.classList.remove('mrt--novt');
      nm.classList.remove('is-cut');
      var cut = nm.scrollWidth > nm.clientWidth + 1;
      if (cut && window.innerWidth <= 480) {
        stage.classList.add('mrt--novt');
        cut = nm.scrollWidth > nm.clientWidth + 1;
      }
      nm.classList.toggle('is-cut', cut);
      var q = stage.querySelector('.mrt__q');
      if (q) q.classList.toggle('is-fade', q.scrollHeight > q.clientHeight + 1);
    }

    // Fill the quote box of the slide on screen (after a draw, a resize and when the fonts load).
    function layoutQuote() {
      var q = stage.querySelector('.mrt__q');
      if (q) fillQuote(q, slides[i]);
    }

    function draw() {
      stage.innerHTML = slideHtml(slides[i]);
      layoutQuote();
      fit();
      if (dotsEl) {
        var ds = dotsEl.children;
        for (var k = 0; k < ds.length; k++) {
          if (k === i) ds[k].setAttribute('aria-current', 'true');
          else ds[k].removeAttribute('aria-current');
        }
      }
    }

    function stopped() {
      return !speed || !many || hold.hover || hold.focus || hold.off || hold.hidden || !!document.querySelector('dialog.mismo-rv[open]');
    }

    function arm() {
      clearTimeout(timer);
      if (!stopped()) timer = setTimeout(function () { go(i + 1, true); }, speed);
    }

    function go(n, fade) {
      i = (n + slides.length) % slides.length;
      if (fade && !REDUCE) {
        stage.classList.add('is-out');
        setTimeout(function () {
          draw();
          stage.classList.remove('is-out');
        }, FADE);
      } else {
        draw();
      }
      arm();
    }

    if (dotsEl) {
      dotsEl.addEventListener('click', function (event) {
        var t = event.target;
        var b = t instanceof Element ? t.closest('[data-mrt-dot]') : null;
        if (b) go(Number(b.getAttribute('data-mrt-dot')), true);
      });
    }

    panel.addEventListener('click', function (event) {
      var t = event.target;
      if (!(t instanceof Element)) return;
      if (t.closest('[data-mrt-prev]')) return go(i - 1, true);
      if (t.closest('[data-mrt-next]')) return go(i + 1, true);
      if (t.closest('[data-mrt-open]')) {
        var r = slides[i].r;
        r.c = (r.cs && r.cs[0]) || '';
        r.cl = '';
        holder.__review = r;
        var btn = holder.querySelector('[data-mismo-review-open]');
        if (btn) btn.click();
      }
    });

    root.addEventListener('mouseenter', function () { hold.hover = true; arm(); });
    root.addEventListener('mouseleave', function () { hold.hover = false; arm(); });
    root.addEventListener('focusin', function () { hold.focus = true; arm(); });
    root.addEventListener('focusout', function () { hold.focus = false; arm(); });
    document.addEventListener('visibilitychange', function () { hold.hidden = document.hidden; arm(); });
    // The pop-up closes: start the cycle again.
    document.addEventListener('close', function (event) {
      var d = event.target;
      if (d instanceof Element && d.matches('dialog.mismo-rv')) arm();
    }, true);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        hold.off = !entries[0].isIntersecting;
        arm();
      }).observe(root);
    }
    window.addEventListener('resize', function () { layoutQuote(); fit(); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { layoutQuote(); fit(); });

    draw();
    arm();
  }

  function initAll() {
    document.querySelectorAll('[data-mrt]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  // Theme editor: a block that is added or changed draws again.
  document.addEventListener('shopify:section:load', function () {
    window.__mrtLoaded = true;
    initAll();
  });
  document.addEventListener('shopify:block:select', initAll);
})();
